import bundle from "./system/bundle";

export * from "./system/bundle";

export default bundle;

/**
 * ------------------------------
 * EXTENSIONS: DOCS
 * ------------------------------
 *
 * Extension follow a template. This is shaped by `system/setup.ts` through the IConfiguration type.
 *
 * ---------------
 * ELEMENTS
 * ---------------
 *
 * 1. shape
 *    - [file: <E>/index.ts] - unique shape identifier
 * 2. initial + I<Extension>
 *    - [file: <E>/config.ts] - used by the create-form for state management and for reflection (casting back)
 * 3. check
 *    - [file: <E>/setup.ts] - used by the create-machines to sync-verify data integrity in onCheck
 * 4. identify
 *    - [file: <E>/setup.ts] - used to revers engineer the extension type
 * 5. simulate
 *   - [file: <E>/setup.ts] - used to create data points to simulate the stream in a chart
 * 6. precompute
 *    - [file: <E>/setup.ts] - two (single, group) methods used to obtain derived data before the process step (8)
 * 7. Form
 *    - [file: <E>/logic.ts] - logic required by the create-form
 *    - [file: <E>/fields.tsx] - UI required by the create-forms, uses logic
 *    - [file: <E>/form.tsx] - wrapper for the extended fields, uses fields
 * 8. process
 *    - [file: <E>/process.ts] - two (singe, group) methods that gather, validate and organize data for the TX
 *                             - used by the create-machines in onProcess
 * 9. summary
 *    - [file: <E>/summary.ts] - used to showcase the tx summary in the forms page, right side
 *
 * ---------------
 * FILES
 * ---------------
 * 1. config.ts (initial, I<Extension>)
 *
 * 2. logic.ts (Form)
 * 3. fields.tsx (Form)
 * 4. form.tsx (Form)
 *
 * 5. process.ts (process)
 * 6. setup.ts (check, identify, precompute, simulate)
 * 7. summary.ts (summary)
 *
 * 8. index.tsx <<<BUNDLE>>>
 *
 */
